"use client";
import clsx from "clsx";
import { useEffect, useState } from "react";

import useUpdateQuantity from "@/lib/hooks/updateQuantity";
import { useDebounce } from "@/lib/hooks/useDebounce";
import styles from "./counter.module.css";

interface IQuantityCounterProps {
  quantity: number;
  line: string;
  max?: number;
  min?: number;
  disabled?: boolean;
}

const getDecreasedQuantity = (quantity: number) =>
  quantity === 0 ? 0 : quantity - 1;

const QuantityCounter = ({
  quantity: cartItemQuantity,
  line,
  min = 0,
  max,
  disabled = false
}: IQuantityCounterProps) => {
  const { updateQuantity } = useUpdateQuantity();

  const [displayQuantity, setDisplayQuantity] = useState(cartItemQuantity);

  const debouncedQuantity = useDebounce(displayQuantity, 500);

  useEffect(() => {
    // Handle case when optimistic update were aligned by server response
    if (cartItemQuantity !== displayQuantity) {
      setDisplayQuantity(cartItemQuantity);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartItemQuantity, setDisplayQuantity]);

  useEffect(() => {
    if (debouncedQuantity !== cartItemQuantity) {
      updateQuantity.mutate({
        line,
        newQuantity: debouncedQuantity
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedQuantity]);

  const increaseQuantity = () => {
    setDisplayQuantity(displayQuantity + 1);
  };

  const decreaseQuantity = () => {
    setDisplayQuantity(getDecreasedQuantity(displayQuantity));
  };

  return (
    <div
      className={`${styles["yarn-quantity"]} ${
        disabled ? styles["yarn-quantity-disabled"] : ""
      } `}
    >
      <div className={styles["quantity-input"]}>
        <label htmlFor="quantity" style={{ display: "none" }}>
          Antall
        </label>

        <button
          disabled={disabled || cartItemQuantity <= min}
          className={clsx(
            styles["quantity-button"],
            cartItemQuantity === 0 && styles["disabled-button"]
          )}
          onClick={decreaseQuantity}
        >
          -
        </button>

        <span>{displayQuantity}</span>

        <button
          disabled={disabled || (!!max && cartItemQuantity >= max)}
          className={clsx(styles["quantity-button"])}
          onClick={increaseQuantity}
        >
          +
        </button>
      </div>
    </div>
  );
};

export default QuantityCounter;
